import { MatomoSources } from '@/matomo/events/MatomoSources';
import {
  MatomoBestFriendEvents,
  MatomoCartEvents,
  MatomoEssenceEvents,
  MatomoInventoryEvents,
  MatomoLabelEvents,
  MatomoLanguageEvents,
  MatomoNotificationEvents,
  MatomoOrderEvents,
  MatomoOrderTemplateEvents,
  MatomoProductEvents,
  MatomoProductImageEvents
} from '@/matomo/events/MatomoTracking';
import MatomoContextMessage, {
  MatomoRestoreMessage,
  MatomoSelfMessage
} from '@/matomo/message/MatomoContextMessage';
import MatomoQuantityMessage from '@/matomo/message/MatomoQuantityMessage';
import MatomoContextualQuantityMessage from '@/matomo/message/MatomoContextualQuantityMessage';

export default class MatomoEvents {

  public static forProductImage = {
    showOther: MatomoProductImageEvents.showOtherImage,
    interaction: MatomoProductImageEvents.imageInteraction
  };

  public static forLabelPage = {
    addLabel: MatomoLabelEvents.addItemLabelList.with(MatomoSources.LABEL_LIST),
    removeLabel: MatomoLabelEvents.removeItemLabelList.with(MatomoSources.LABEL_LIST),
    removeAll: MatomoLabelEvents.removeAllLabelList.with(MatomoSources.LABEL_LIST),
    generateList: MatomoLabelEvents.generateLabelList,
    changeItemAmount: MatomoLabelEvents.changeItemAmount.with(MatomoSources.LABEL_LIST)
  };

  public static forLabelToggle = {
    addLabel: MatomoContextMessage.from(MatomoLabelEvents.addItemLabelList),
    removeLabel: MatomoContextMessage.from(MatomoLabelEvents.removeItemLabelList)
  };

  public static forCartPage = {
    amountChange: MatomoQuantityMessage.from(MatomoProductEvents.productChangeAmount.with(MatomoSources.CART)),
    unitChange: MatomoQuantityMessage.from(MatomoProductEvents.productUnitChange.with(MatomoSources.CART)),
    restoreItem: MatomoCartEvents.restoreToCart,
    removeItem: MatomoCartEvents.removeItemFromCart.with(MatomoSources.CART),
    removeAllProducts: MatomoCartEvents.removeAllItemsFromCart.with(MatomoSources.CART)
  };

  public static forDetailPage = {
    amountChange: MatomoQuantityMessage.from(
      MatomoProductEvents.productChangeAmount.with(MatomoSources.PRODUCT_DETAIL)
    ),
    unitChange: MatomoQuantityMessage.from(
      MatomoProductEvents.productUnitChange.with(MatomoSources.PRODUCT_DETAIL)
    ),
    removeItem: MatomoCartEvents.removeItemFromCart.with(MatomoSources.PRODUCT_DETAIL),
    addItem: MatomoCartEvents.addItemToCart.with(MatomoSources.PRODUCT_DETAIL)

  };

  public static forSearch = {
    unitChange: MatomoQuantityMessage.from(MatomoProductEvents.productUnitChange.with(MatomoSources.SEARCH)),
    amountChange: MatomoQuantityMessage.from(MatomoProductEvents.productChangeAmount.with(MatomoSources.SEARCH)),
    addItem: MatomoCartEvents.addItemToCart.with(MatomoSources.SEARCH),
    removeItem: MatomoCartEvents.removeItemFromCart.with(MatomoSources.SEARCH),
  };

  public static forPromoted = {
    removeItem: MatomoCartEvents.removeItemFromCart.with(MatomoSources.PROMOTED_PRODUCT),
    addItem: MatomoCartEvents.addItemToCart.with(MatomoSources.PROMOTED_PRODUCT)
  };

  public static forBestfriend = {
    addAllProducts: MatomoCartEvents.addAllItemsToCart.with(MatomoSources.BEST_FRIEND),
    deleteOpenOrder: MatomoBestFriendEvents.bestFriendDeleteOpenOrder
  };

  public static forOrderTemplates = {
    addAllProducts: MatomoCartEvents.addAllItemsToCart.with(MatomoSources.ORDER_TEMPLATE),
    downloadPdf: MatomoOrderTemplateEvents.downloadOrderTemplatePdf,
    change: MatomoOrderTemplateEvents.orderTemplateChangeOrderTemplate,
    addTemplate: MatomoContextMessage.from(MatomoOrderTemplateEvents.addTemplate),
    removeTemplate: MatomoOrderTemplateEvents.removeTemplate.with(MatomoSources.ORDER_TEMPLATE_DETAILS),
    addProduct: MatomoContextMessage.from(MatomoOrderTemplateEvents.addProduct),
    removeProduct: MatomoContextMessage.from(MatomoOrderTemplateEvents.removeProduct)
  };

  public static forProductListItem = {
    unitChange: MatomoContextualQuantityMessage.from(MatomoProductEvents.productUnitChange),
    amountChange: MatomoContextualQuantityMessage.from(MatomoProductEvents.productChangeAmount),
    addItem: MatomoContextMessage.from(MatomoCartEvents.addItemToCart),
    removeItem: MatomoContextMessage.from(MatomoCartEvents.removeItemFromCart),
    removeFromTemplate: MatomoSelfMessage.from(MatomoOrderTemplateEvents.removeProduct),
    restoreToTemplate: MatomoRestoreMessage.from(MatomoOrderTemplateEvents.addProduct),
    templateChange: MatomoContextMessage.from(MatomoOrderTemplateEvents.changeProduct)
  };

  public static forEssences = {
    toggleDropdown: MatomoContextMessage.from(MatomoEssenceEvents.toggleDropdown),
    addAllItemsToLabelPrint: MatomoLabelEvents.addAllItemsToLabelList.with(MatomoSources.ESSENTIAL)
  };

  public static forDatasheet = {
    download: MatomoProductEvents.downloadDatasheet
  };

  public static forLanguage = {
    change: MatomoLanguageEvents.changeLanguage
  };

  public static forNotifications = {
    read: MatomoNotificationEvents.readNotifications
  };

  public static forInventory = {
    delete: MatomoInventoryEvents.deleteInventory
  };

  public static forOrder = {
    downloadConfirmation: MatomoOrderEvents.cartOrderConfirmationDownload
  };
}
